import { useQueryClient } from 'react-query';
import { createQueryData } from '../helpers/createQueryData';
import { useEvent } from '../../../../hooks/useEvent';

const endPoint = 'Acceptance/report_records_by_date';

const { createKey, fn } = createQueryData({
  endPoint,
  options: {
    errorMessage: 'Не удалось загрузить записи на приемку',
  },
});

export const useFetchReportOnAcceptanceRecords = () => {
  const queryClient = useQueryClient();

  return useEvent(({ acceptanceId, targetDate }) => {
    const params = { acceptanceId, targetDate };
    return queryClient.fetchQuery(createKey(params), () => fn(params));
  });
};
